<template>
  <billing-report-panel
    report-key="payment-time"
    route="/reports/billing-payment-time"
    file-name="prazo-medio-de-recebimento.xlsx"
    period-label="Período do pagamento"
    :columns="columns"
    :default-days="360"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Convênio e plano',
        'Lotes pagos',
        'Prazo médio em dias',
        'Menor prazo',
        'Maior prazo',
        'Mediana',
        'Prazo previsto no plano',
        'Diferença entre previsto e real',
      ],
    };
  },
};
</script>
